module.exports = __webpack_public_path__ + "media/images/sec_6-3-757a492213cc64cf3ecf5fe69b942495.png";